/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Seo_Site_Name1Inputs */

const vi_sitesettings_seo_site_name1 = /** @type {(inputs: Sitesettings_Seo_Site_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên website (og:site_name)`)
};

/**

* @param {Sitesettings_Seo_Site_Name1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_seo_site_name1 = /** @type {((inputs?: Sitesettings_Seo_Site_Name1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Seo_Site_Name1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_seo_site_name1(inputs)
});
export { sitesettings_seo_site_name1 as "siteSettings_seo_site_name" }